import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export const useSettingsPageDimensions = () => {
  const [collapsed, setCollapsed] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const collapsedSize = useMemo(() => (1440 * 2) / windowWidth, [windowWidth]);
  const minSidebarSize = useMemo(() => (1440 * 15) / windowWidth, [windowWidth]);
  const defaultSidebarSize = useMemo(() => (1440 * 18) / windowWidth, [windowWidth]);
  const maxSidebarSize = useMemo(() => (1440 * 20) / windowWidth, [windowWidth]);

  const sidebarRef = useRef(null);

  const expandSidebar = useCallback(() => {
    if (sidebarRef.current) {
      sidebarRef.current.expand();
      setCollapsed(false);
    }
  }, []);

  return {
    collapsed,
    setCollapsed,
    collapsedSize,
    minSidebarSize,
    defaultSidebarSize,
    maxSidebarSize,
    sidebarRef,
    expandSidebar,
  };
};
